export default __webpack_public_path__ + "static/valve_w.adb08e3c68bec17a1883213edd48a0a5.svg";